import { createAction } from '@reduxjs/toolkit';

export const selectQuestion = 'dora/vc/selectQuestion';
export const selectProperty = 'dora/vc/selectProperty';
export const selectAttachmentOption = 'dora/vc/selectAttachmentOption';
export const user3dSceneInteraction = 'dora/vc/user3dSceneInteraction';
export const undo = 'dora/vc/undo';
export const redo = 'dora/vc/redo';
export const share = 'dora/vc/share';
export const error = 'dora/vc/error';

// Visual Configuration
export const selectQuestionAction =
    createAction<{ category: string; type: string }>(selectQuestion);
export const selectPropertyAction = createAction<{
    category: string;
    type: string;
    newOption: string;
    previousOption: string;
    choiceIsCompatible: boolean;
}>(selectProperty);
export const selectAttachmentOptionAction = createAction<{
    attachmentTag: string;
    value: string;
}>(selectAttachmentOption);
export const user3dSceneInteractionAction = createAction(user3dSceneInteraction);
export const undoAction = createAction(undo);
export const redoAction = createAction(redo);
export const shareAction = createAction(share);

export type ConfigurationError = 'catch all' | 'renderer';
export const errorAction =
    createAction<{ reason: string; type: ConfigurationError; productId?: string }>(error);
